/**
 * Shopify Country Blocker
 * Bloqueia visitantes do Brasil usando APIs públicas de IP e proxy
 */

var ZARCD = {};
var ZACB = {};

// Funções de cookie
ZACB = {
    createCookie: function(name, value, days) {
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            var expires = "; expires=" + date.toGMTString();
        } else {
            expires = "";
        }
        document.cookie = name + "=" + value + expires + "; path=/";
    },
    readCookie: function(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    },
    eraseCookie: function(name) {
        ZACB.createCookie(name, "", -1);
    }
};

// Função para carregar scripts dinamicamente
ZARCD.loadScript = function(url, callback) {
    var script = document.createElement("script");
    script.type = "text/javascript";
    if (script.readyState) {
        script.onreadystatechange = function() {
            if (script.readyState == "loaded" || script.readyState == "complete") {
                script.onreadystatechange = null;
                callback();
            }
        };
    } else {
        script.onload = function() {
            callback();
        };
    }
    script.src = url;
    document.getElementsByTagName("head")[0].appendChild(script);
};

// Verificar se o país está bloqueado
ZACB.za_is_c_b = function(country_code) {
    var za_user_country = country_code;
    // Verificar múltiplas variações do código do Brasil
    return (za_user_country === 'BR' || 
            za_user_country === 'Brazil' || 
            za_user_country === 'BRA' ||
            za_user_country === 'br' ||
            za_user_country === 'brazil');
};

// Verificar se o usuário está usando proxy
ZACB.CheckUserProxy = function() {
    // Só verificar proxy quando país já identificado como Brasil e IP disponível
    if (!ZACB.za_ip || !ZACB.za_code || !ZACB.za_is_c_b(ZACB.za_code)) {
        return;
    }
    try {
        var xhttp = new XMLHttpRequest();
        xhttp.onreadystatechange = function() {
            if (this.readyState == 4 && this.status == 200) {
                var resp = JSON.parse(xhttp.responseText);
                if (typeof(resp[ZACB.za_ip]) !== "undefined") {
                    if (resp[ZACB.za_ip]['proxy'] == "yes") {
                        ZACB.za_html();
                    }
                }
            }
        };
        xhttp.open("GET", "https://proxycheck.zend-apps.com/" + ZACB.za_ip + ".js", true);
        xhttp.send();
    } catch (e) {
        console.log("Erro ao verificar proxy:", e);
    }
};

// Verificar se o estado está bloqueado
ZACB.is_state_blocked = function(user_country, user_state) {
    var BlockStatesArr = JSON.parse('[]', true);
    if (typeof(BlockStatesArr[user_country]) !== "undefined") {
        return BlockStatesArr[user_country].indexOf(user_state) != -1;
    } else {
        return false;
    }
};

// Funções auxiliares para IP
ZACB.za_getIpByPos = function(ip, pos) {
    if (pos === undefined) {
        pos = 0;
    }
    var explode_array = ip.split(".");
    return (explode_array[pos]);
};

ZACB.za_checkIpInList = function(ip, listarr) {
    var clientip = ZACB.za_getIpByPos(ip, 3);
    var result = false;
    if (typeof listarr == "undefined") {
        return result;
    }
    listarr.forEach(function(item) {
        var beforeIps = true;
        for (j = 0; j <= 2; j++) {
            var client_ip_pos = ZACB.za_getIpByPos(ip, j);
            var start_ip_pos = ZACB.za_getIpByPos(item['start_ip'], j);
            var end_ip_pos = ZACB.za_getIpByPos(item['end_ip'], j);
            if (client_ip_pos != start_ip_pos || client_ip_pos != end_ip_pos) {
                beforeIps = false;
                break;
            }
        }
        if (beforeIps == false) {
            return true;
        }
        var startip = ZACB.za_getIpByPos(item['start_ip'], 3);
        var endip = ZACB.za_getIpByPos(item['end_ip'], 3);
        if (clientip >= startip && clientip <= endip) {
            result = true;
        }
    });
    return result;
};

// Efeito de fade in
ZACB.fadeIn = function(element) {
    element.style.opacity = 0;
    var op = 0.01;
    var timer = setInterval(function() {
        if (op >= 1) {
            clearInterval(timer);
        }
        element.style.opacity = op;
        element.style.filter = 'alpha(opacity=' + (op * 100) + ")";
        op += op * 0.1;
    }, 10);
};

// Função de login com senha (vazia por enquanto)
ZACB.login_with_pass = function() {};

// Registrar usuário bloqueado
ZACB.RecordUser = function() {
    try {
        var action = "Blocked";
        var path_name = window.location.pathname;
        var xhttp = new XMLHttpRequest();
        var data_url = "store_data=" + "MTEwMjM=" + "&ip=" + ZACB.za_ip + "&country=" + ZACB.za_code + "&action=" + action + "&url=" + path_name;
        xhttp.open("POST", "https://cb-analytics.zend-apps.com/save-log-data?" + data_url, true);
        xhttp.setRequestHeader("Authorizations", "d2Utd2lsbC1jaGVjay10aGlzLWJlZm9yZS1zYXZpbmctdGhlLWxvZ3MtZGF0YQ==");
        xhttp.send(data_url);
    } catch (e) {
        console.log("Erro ao registrar usuário:", e);
    }
};

// Obter informações de IP usando API pública
ZACB.getIPInfo = function() {
    return new Promise((resolve, reject) => {
        console.log('Iniciando verificação de IP...');
        
        // Usar múltiplas APIs para maior confiabilidade
        const apis = [
            'https://ipapi.co/json/',
            'https://ipinfo.io/json',
            'https://api.ipify.org?format=json',
            'https://ip-api.com/json/',
            'https://freeipapi.com/api/json'
        ];
        
        let completed = 0;
        let result = null;
        let errors = 0;
        
        apis.forEach((api, index) => {
            console.log(`Tentando API ${index + 1}: ${api}`);
            
            fetch(api, { 
                method: 'GET',
                mode: 'cors',
                cache: 'no-cache'
            })
                .then(response => {
                    console.log(`API ${api} respondeu com status:`, response.status);
                    if (!response.ok) throw new Error(`HTTP ${response.status}: ${response.statusText}`);
                    return response.json();
                })
                .then(data => {
                    console.log(`Dados recebidos da API ${api}:`, data);
                    if (!result && data) {
                        // Normalizar dados de diferentes APIs
                        result = {
                            ip: data.ip || data.query || data.query_ip,
                            country: data.country_code || data.country || data.countryCode,
                            region: data.region || data.regionName || data.region_code,
                            city: data.city || data.cityName
                        };
                        
                        // Log para debug
                        console.log('✅ IP detectado com sucesso:', result);
                    }
                    completed++;
                    if (completed === apis.length) {
                        if (result) {
                            resolve(result);
                        } else {
                            console.log('❌ Nenhuma API retornou dados válidos; permitindo acesso.');
                            resolve(null);
                        }
                    }
                })
                .catch(error => {
                    errors++;
                    completed++;
                    console.log(`❌ Erro na API ${api}:`, error.message);
                    if (completed === apis.length && !result) {
                        console.log('❌ Todas as APIs falharam; permitindo acesso.');
                        resolve(null);
                    }
                });
        });
    });
};

// Substituir HTML da página
ZACB.za_html = function() {
    try {
        window.stop();
        window.ShopifyAnalytics = {};
    } catch (err) {}
    
    var html = document.getElementsByTagName("html")[0];
    while (html.firstChild) {
        html.removeChild(html.firstChild);
    }
    html.style.opacity = 0;
    
    html.innerHTML = `<html class="js" lang="pt-BR" dir="ltr" style="opacity: 1;">
<head>
  <title>O que aconteceu?</title>

  <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no">
  <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.1.3/dist/css/bootstrap.min.css" rel="stylesheet">

  <!-- FontAwesome -->
  <link href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.1/css/all.min.css" rel="stylesheet" crossorigin="anonymous">

  <link href="https://fonts.googleapis.com/css?family=Lato:300,400,500,600,700,900" rel="stylesheet" type="text/css">

  <style>
    body { 
      background: #ffffff; 
      margin: 0; 
      padding: 0; 
      font-family: Lato, sans-serif; 
      color:#6b6b6b; 
    }

    .cb-page {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }

    .cb-units {
      position: absolute;
      top: 25%; /* Posição padrão desktop */
      left: 50%;
      transform: translateX(-50%);
      width: 42%;
      max-width: 600px;
      padding: 20px;
      border-radius: 7px;
      
    }

    .error-code { 
      font-size: 22px; 
      display: flex; 
      
      gap: 10px; 
    }
    .error-code i { font-size: 28px; color: #e9be33; }
    .error-title { font-size: 17px; margin-top: 20px; }
    .error-subtitle { font-size: 16px; margin: 15px 0; }
    .contact-info { font-size: 16px; margin-top: 20px; }

    .cb-inner ul { padding:0; list-style:none; }
    .cb-inner ul li { margin:5px 0; }
    .cb-inner ul a { color:#479ccf; text-decoration: underline; }
    .cb-inner hr { width:80px; }

    /* Mobile: joga mais para o topo */
    @media (max-width: 768px) {
      .cb-units {
        top: 10%;   /* fica mais próximo do topo */
        width: 90%; /* ocupa mais largura */
      }
      .error-code { font-size: 18px; }
      .error-code i { font-size: 24px; }
    }
  </style>
</head>
<body>
  <div class="page">
    <div class="cb-page">
      <div class="cb-units">
        <div class="cb-inner">
          <div class="cb-text-unit">
            <h2 class="error-code">
              <i class="fa fa-exclamation-triangle"></i>
              Oops, something went wrong.
            </h2>
            <p class="error-title">What happened?</p>
            <hr>
            <p class="error-subtitle">This shop is unavailable</p>
            <p class="contact-info">What can I do?</p>
            <ul>
              <li>Press the back button on your browser.</li>
              <li><a href="javascript:history.back()">Return to the previous page.</a></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</body>
</html>

`;
    
    ZACB.fadeIn(html);
    
    // Verificar se FontAwesome carregou e mostrar fallback se necessário
    setTimeout(function() {
        var faIcon = document.querySelector('.fa.fa-times-circle');
        var svgFallback = document.querySelector('.icon-fallback');
        
        if (faIcon && window.getComputedStyle(faIcon, ':before').content === 'none') {
            // FontAwesome não carregou, mostrar SVG
            if (svgFallback) {
                svgFallback.style.display = 'block';
                faIcon.style.display = 'none';
            }
        }
    }, 1000);
};

// Função principal de verificação de país
ZACB.za_c_b = function() {
    console.log('🚀 Iniciando verificação de bloqueio de país...');
    
    // Nenhum IP permitido - todos os IPs do Brasil serão bloqueados
    var whitelistarr = JSON.parse('[]');
    var blacklistarr = JSON.parse('[]');
    var IPv6 = JSON.parse('[]');
    var White_IPv6 = JSON.parse('[]');
    
    // Nenhum bypass permitido - todos os IPs do Brasil serão bloqueados
    
    // Obter informações de IP
    ZACB.getIPInfo().then(data => {
        if (data) {
            ZACB.za_code = data.country || '';
            ZACB.za_state = data.region || '';
            ZACB.za_ip = data.ip || '';
            ZACB.pseudo_ip = "null";
            
            var ip = ZACB.za_ip;
            var country_code = ZACB.za_code;
            var state_code = ZACB.za_state;
            
            console.log('📍 Dados do usuário:', {
                ip: ip,
                país: country_code,
                estado: state_code,
                cidade: data.city || 'N/A'
            });
            
            // Verificar IPv6
            if (IPv6.indexOf(ip) > -1) {
                console.log('🚫 IPv6 detectado, bloqueando...');
                ZACB.za_html();
                return;
            }
            
            try {
                if (ZACB.za_ip.length > 15 && ZACB.pseudo_ip != null) {
                    ZACB.za_ip = ZACB.pseudo_ip;
                }
            } catch (err) {}
            
            // Verificar se é Brasil (código BR) - bloquear somente Brasil
            if (country_code === 'BR' || country_code === 'Brazil' || country_code === 'BRA') {
                console.log('🇧🇷 Brasil detectado - BLOQUEANDO TODOS OS IPs');
                ZACB.RecordUser();
                ZACB.za_html();
            } else {
                console.log('✅ IP não é do Brasil, permitindo acesso');
                return true;
            }
        } else {
            console.log('❌ Dados de IP não obtidos; permitindo acesso.');
            return true;
        }
    }).catch(error => {
        console.log("❌ Erro ao obter informações de IP:", error);
        // Em caso de erro, permitir acesso (bloquear somente Brasil)
        console.log('ℹ️ Erro na verificação; permitindo acesso.');
        return true;
    });
};

// Inicializar quando a página carregar
if (window.location.href === window.top.location.href) {
    ZACB.za_c_b();
    ZACB.CheckUserProxy();
}
